var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, AuthService, UserService } from '@base/shared/services';
import * as moment from 'moment';
import { environment } from '@env/environment';
var SafeProxReportModal = /** @class */ (function () {
    function SafeProxReportModal(activeModal, activeRoute, formBuilder, api, helpers, authService, accountService) {
        this.activeModal = activeModal;
        this.activeRoute = activeRoute;
        this.formBuilder = formBuilder;
        this.api = api;
        this.helpers = helpers;
        this.authService = authService;
        this.accountService = accountService;
        this.loading = false;
        this.album = {};
        this.data = {};
        this.displayWarning = false;
        this.warningMessage = '';
        this.rootContractId = this.accountService.account.contract.contractId;
        this.readOnly = false;
        this.isMobile = false;
        this.currentDate = new Date();
        this.endDate = new Date();
    }
    SafeProxReportModal.prototype.streamOpened = function () { };
    SafeProxReportModal.prototype.streamClosed = function () {
    };
    /** TODO: use note.component */
    SafeProxReportModal.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.sectionId = this.activeRoute.snapshot.paramMap.get('id');
                ;
                this.queryParams = this.activeRoute.snapshot.queryParams;
                this.bootstrapForm();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Initialize photo form
     */
    SafeProxReportModal.prototype.bootstrapForm = function () {
        var startDate = moment(this.currentDate).subtract(2, 'week').toDate();
        var endDate = moment(this.endDate).toDate();
        this.reportForm = this.formBuilder.group({
            startDate: [
                { value: startDate, disabled: true }, [Validators.required]
            ],
            endDate: [
                { value: endDate, disabled: true }, [Validators.required]
            ]
        });
    };
    SafeProxReportModal.prototype.dateChange = function (data) {
        var startDate = moment(this.reportForm.get('startDate').value);
        var endDate = moment(this.reportForm.get('endDate').value);
        var diff = endDate.diff(startDate, 'days');
        if (diff >= 180) {
            this.warningMessage = 'workforce.report.180warning';
            this.displayWarning = true;
            this.resetWarningMessage();
            this.helpers.setFormError(this.reportForm, false);
        }
        if (diff < 0) {
            this.warningMessage = 'Invalid date range';
            this.displayWarning = true;
            this.resetWarningMessage();
            this.helpers.setFormError(this.reportForm, false);
        }
    };
    SafeProxReportModal.prototype.resetWarningMessage = function () {
        var _this = this;
        setTimeout(function () {
            _this.warningMessage = '';
            _this.displayWarning = false;
        }, 5000);
    };
    SafeProxReportModal.prototype.onSubmit = function (_a) {
        var _this = this;
        var value = _a.value;
        var params = {
            startDateInclusive: moment(value['startDate']).format('YYYY-MM-DD'),
            endDateInclusive: moment(value['endDate']).format('YYYY-MM-DD')
        };
        var workerId = this.data['workerId'];
        var contractId = this.data['mainContractId'];
        this.loading = true;
        this.api.contracts.runContractSafeProxReport(contractId, workerId, params).toPromise()
            .then(function (res) {
            _this.download(res.uid);
            _this.cancel();
        })
            .catch(function (error) {
            _this.helpers.errorMessage(error);
            _this.loading = false;
        });
    };
    SafeProxReportModal.prototype.download = function (source) {
        if (source) {
            window.open(environment.baseUrl + "/v2/downloads/file?uid=" + source, '_blank');
        }
        this.loading = false;
    };
    SafeProxReportModal.prototype.goBack = function () {
        this.closeModal();
    };
    /**
     * Cancel note creation / edition
     */
    SafeProxReportModal.prototype.cancel = function () {
        this.closeModal({});
    };
    /**
     * Close current Modal
     * @param {[type]} result [description]
     */
    SafeProxReportModal.prototype.closeModal = function (result) {
        this.activeModal.close(result);
    };
    return SafeProxReportModal;
}());
export { SafeProxReportModal };
